var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main",class:{ 'is-menu-opened': _vm.navbar.menuOpened },style:([_vm.hiddenSidebarStyle])},[_c('div',{staticClass:"container is-fluid is-marginless app-content"},[_c('levelbar'),_c('transition',{attrs:{"name":"route-fade","mode":"out-in","appear":""}},[_c('div',{staticClass:"box"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }